module.exports = __webpack_public_path__ + "static/CoverManager-dda629634be4331d17eec703a5ad69b0.svg";